export interface BeneficiarySwiftRouteFields {
  routingCodeType1?: string | null;
  routingCodeType2?: string | null;
  routingCodeType3?: string | null;
  routingCodeValue1?: string | null;
  routingCodeValue2?: string | null;
  routingCodeValue3?: string | null;
}

const routingTypesChecker: (keyof BeneficiarySwiftRouteFields)[] = [
  'routingCodeType1',
  'routingCodeType2',
  'routingCodeType3',
  'routingCodeValue1',
  'routingCodeValue2',
  'routingCodeValue3',
];

export const checkIfBeneficiaryHasSwiftRoute = (beneficiary: BeneficiarySwiftRouteFields): boolean => {
  return routingTypesChecker.some(key => beneficiary?.[key]?.toUpperCase().includes('SWIFT'))
}
